import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, lifecycle } from 'recompose';

import { isCurrentLanguageRtl } from 'modules/language/selectors/language';
import { fetchOrganizations } from 'modules/auth/actions/fetchOrganizations';

import {
  selectOrganizationToken,
  handleOrganizationSelectionFocus,
  submitOrganizationSelectionForm as submitForm,
} from '../../actions/organizationSelection';
import { resetRouteToRedirect } from '../../actions/redirect';
import OrganizationSelectionForm from './OrganizationSelectionForm';

const mapStateToProps = (state) => {
  const organizations = state.auth.organizations.organizationsList;

  const organizationsOptions = organizations
    ? organizations
      .map((item) => ({
        key: item.orgId,
        value: item.name,
        iconName: 'organization',
      }))
    : [];

  const selectedOrganization = organizationsOptions
    .find((item) => item.key === state.auth.organizations.selectedOrganizationToken);

  return {
    rtl: isCurrentLanguageRtl(),
    organizations: state.auth.organizations,
    organizationsOptions,
    selectedOrganization,
  };
};

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    fetchOrganizations,
    handleOrganizationSelectionFocus,
    submitForm,
  }, dispatch),

  selectOrganizationToken: selectedOrganizationToken => {
    dispatch(selectOrganizationToken(selectedOrganizationToken));
    dispatch(resetRouteToRedirect());
  },
});


export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

  lifecycle({
    componentDidMount() {
      this.props.fetchOrganizations();
    },
  }),

  injectIntl,
)(OrganizationSelectionForm);
